import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setBearerToken } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      try {
        const hash = location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
          navigate("/login");
          return;
        }
        const sessionId = decodeURIComponent(m[1]);
        const r = await api.post("/auth/session", { session_id: sessionId });
        if (r.data?.session_token) setBearerToken(r.data.session_token);
        // Clean hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data?.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Erreur d'authentification";
        navigate("/login", { replace: true, state: { error: typeof msg === "string" ? msg : "Erreur" } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-auth)]">
      <div className="text-sm text-stone-600">Connexion en cours…</div>
    </div>
  );
}
